module.exports = __webpack_public_path__ + "static/media/templateDownload.965e1615.png";